import React, { useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid2 as Grid,
  IconButton,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from '@mui/material'
import ProfileSelectionCard from '../../../components/ProfileSelectionCard'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Colors from '../../../utils/colors.json'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const styles = (theme: any) => ({
  docsBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '10px',
  },
  borderContainer: {
    borderRadius: '20px',
    border: '1px solid #546B8D',
    color: Colors.WHITE_BACKGROUND,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    padding: '4px 4px 3px 3px',
    gap: '8px',
  },
  copaySelect: {
    borderRadius: '20px',
    fontSize: '12px',
    background: Colors?.WHITE_BACKGROUND,
  },
  labTestAccordion: {
    width: '100%',
    background: theme.palette.primary.light,
    '&:before': {
      display: 'none',
    },
  },
  labTestAccordionSummary: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  labTestLabel: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.8px',
    color: theme.customColors.textColorMain,
  },
  labTestStatus: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21.1px',
    color: Colors?.FAQ_VALUE,
  },
})

function LabTests() {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  // eslint-disable-next-line
  const [candidates, setCandidates] = useState([
    {
      name: 'Vinod Gadde',
      role: 'Father',
      age: 29,
      avatarSrc: 'https://i.pravatar.cc/150?img=3',
      selected: false,
    },
    {
      name: 'Sunitha Reddy',
      role: 'Mother',
      age: 27,
      avatarSrc: 'https://i.pravatar.cc/150?img=4',
      selected: false,
    },
    {
      name: 'Rohit Gadde',
      role: 'Son',
      age: 7,
      avatarSrc: 'https://i.pravatar.cc/150?img=5',
      selected: false,
    },
  ])
  const [selectedCandidate, setSelectedCandidate] = useState(
    candidates?.[0]?.name
  )
  // eslint-disable-next-line
  const [labTests, setLabTests] = useState([
    { name: 'CBP (Complete Blood Picture)', status: 'Completed' },
    {
      name: 'HbAIC (Glycosylated Hemoglobin EDTA Whole Blood)',
      status: 'Completed',
    },
    { name: 'LFT (Liver Function Test)', status: 'Completed' },
    { name: 'BFT (Renal Function Test)', status: 'Completed' },
    { name: 'TFT (Thyroid Function Test)', status: 'Completed' },
  ])

  return (
    <Grid container spacing={3}>
      <Grid
        container
        spacing={1}
        direction={'row'}
        position={'sticky'}
        top={0}
        zIndex={1}
        size={{ xs: 12 }}
      >
        {candidates?.map((item, index) => {
          return (
            <Grid size='auto' key={index}>
              <ProfileSelectionCard
                name={item?.name}
                role={item?.role}
                age={item?.age}
                avatarSrc={item?.avatarSrc}
                selected={selectedCandidate === item?.name}
                onClick={() => {
                  setSelectedCandidate(item?.name)
                }}
                section={
                  selectedCandidate === item?.name ? (
                    <Box
                      display={'flex'}
                      flexDirection={'row'}
                      justifyContent={'start'}
                      alignItems={'center'}
                      ml={2}
                      gap={2}
                    >
                      <Box className={classes?.borderContainer}>
                        <Typography fontSize={'13px'}>Discount</Typography>
                        <Select
                          value={65}
                          size='small'
                          className={classes?.copaySelect}
                        >
                          <MenuItem value={65}>65%</MenuItem>
                          <MenuItem value={75}>75%</MenuItem>
                          <MenuItem value={95}>95%</MenuItem>
                        </Select>
                      </Box>
                      <Box className={classes?.borderContainer}>
                        <IconButton color='inherit' size='small'>
                          <CloudDownloadIcon />
                        </IconButton>
                        <Typography fontSize={'13px'}>Docs</Typography>
                      </Box>
                    </Box>
                  ) : null
                }
              />
            </Grid>
          )
        })}
      </Grid>
      <Grid container>
        {labTests?.map((test, index) => (
          <Accordion
            className={classes?.labTestAccordion}
            key={index}
            elevation={0}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`faq-content-${index}`}
              id={`faq-header-${index}`}
            >
              <Box className={classes?.labTestAccordionSummary}>
                <Typography className={classes?.labTestLabel}>
                  {test?.name}
                </Typography>
                <Typography className={classes?.labTestStatus} mr={2}>
                  {test?.status}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Really boy law county she unable her sister. Feet you off its
                like six. Among sex are leave law built now. Inbuilt table in an
                rapid blush. Merits behind on afraid or warmly.
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
    </Grid>
  )
}

export default LabTests
